import * as React from "react";
import { request, resourceLink } from "../../../../services/cpln";
import { Secret } from "../../../../schema/types/secret/entity";
import { store } from "../../../../store";
import { formSetValue, useCpFormValue } from "../../../gvc/testNewForm/utils";
import { WorkloadInput } from "../../../../schema/types/workload/input";
import { cloneDeep } from "lodash";
import { useDebounce } from "../../../../components/table/useDebounce";
import { useCpFormContext } from "../../../../components/form/useCpFormContext";

export const CacheProcessor: React.FC = () => {
  const { id } = useCpFormContext();
  const containers = useCpFormValue(`containers`);
  const [debouncedContainers, setDebouncedContainers] = useDebounce(containers, 200);

  React.useEffect(() => {
    setDebouncedContainers(containers);
  }, [containers]);

  React.useEffect(() => {
    processSecrets();
  }, [debouncedContainers]);

  async function processSecrets() {
    const form = store.getState().form.instances[id];
    const values: WorkloadInput = form.values;
    const secretCache = values.meta.secretCache;
    const _secretCache = cloneDeep(secretCache);

    const secretNames: string[] = [];
    for (const container of containers) {
      for (const env of container.env) {
        if (env.prefix !== `cpln://secret/`) {
          continue;
        }
        if (!env.cplnSecret.value) {
          continue;
        }
        secretNames.push(env.cplnSecret.value);
      }
      for (const vol of container.volumes) {
        if (vol.uriType !== `cpln://secret/`) {
          continue;
        }
        if (!vol.secret.value) {
          continue;
        }
        secretNames.push(vol.secret.value);
      }
    }

    for (const secretName of secretNames) {
      if (!!_secretCache[secretName]) {
        continue;
      }

      try {
        const secretLink = resourceLink("secret", secretName);
        const { data } = await request<Secret>({ url: secretLink });
        _secretCache[secretName] = data;
      } catch (e) {
        console.log(`failed to get secret for cache`, e.message);
      }
    }
    formSetValue(id, `meta.secretCache`, _secretCache);
  }

  return null;
};
